module.exports = "/_next/static/images/trolley-66460abd2cd7d133acd7e60ff960a97e.png";